import React from 'react';
import { Route } from 'react-router-dom';
import { Login } from '../ui/auth/Login';

export const authRoutes = [
    <Route path="/login" element={<Login />} key="login" />,
];

